import "shared/extensions/date";

import { ChartFilters } from "../../../../UIPalette/components/Charts/ChartProps";

export const filtersReducer = (
  state: ChartFilters,
  action: {
    type: string;
    payload: any;
  }
): ChartFilters => {
  switch (action.type) {
    case "SET_FROM_DATE":
      if (action.payload) {
        return { ...state, dateFrom: action.payload?.toDateOnly() };
      }
      return state;

    case "SET_TO_DATE":
      if (action.payload) {
        return { ...state, dateTo: action.payload?.toDateOnly() };
      }
      return state;

    case "SET_GROUPING":
      if (action.payload) {
        return { ...state, groupBy: action.payload.toString() };
      }
      return state;

    case "SET_CLIENT_AND_DIVISION":
      return {
        ...state,
        client: action.payload.client,
        division: action.payload.division,
      };

    case "SET_TARGET_GROUP":
      if (!action.payload) return state;
      const targetGroupClients = action.payload.clients;
      return { ...state, targetGroupClients };

    case "SET_DIVISION":
      if (action.payload === "") {
        return { ...state, division: undefined };
      }
      return { ...state, division: action.payload };

    case "SET_LOCALE":
      if (action.payload === "" || action.payload === "all") {
        return { ...state, localeId: undefined };
      }
      return { ...state, localeId: action.payload };

    default:
      return state;
  }
};
